// import React, { useState, useEffect } from "react";
// import s from "./language.module.css";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate } from "react-router-dom";
// import Custombutton from "../../Common/Custombutton";
// import { notificationHandler } from "../../utils/Notification";
// import { useLocation } from "react-router-dom";
// import { Card, Grid } from "@mui/material";
// import RichTextEditor from "react-rte-17";
// import { get_all_tag_list, get_all_tag_list_dropdown } from "../api/tag";
// import MultipleSelect from "./MultipleSelect";
// import { addLanguage_api, updateLanguage_api } from "../api/librarymedia";

// const AddLibraryMedia = (props) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [titleEnglish, settitleEnglish] = useState("");
//   const [titleHindi, settitleHindi] = useState("");
//   const [descEnglish, setdescEnglish] = useState("");
//   const [descHindi, setdescHindi] = useState("");
//   const [url, seturl] = useState("");
//   const [thumbnail, setthumbnail] = useState("");
//   const [rte, setrte] = useState(RichTextEditor.createEmptyValue());
//   const [rte2, setrte2] = useState(RichTextEditor.createEmptyValue());

//   // console.log(rte2, "--------------------rte2 value==========================================================================")

//   const [tags, settags] = useState([]);

//   const [allTag, setallTag] = useState([]); // tag list data

//   const pagetype = location.state.pagetype;

//   useEffect(() => {
//     fetchallTagFunc();
//   }, []);

//   useEffect(() => {
//     if (pagetype == "Edit") {
//       settitleEnglish(location?.state?.data?.titleEnglish);
//       settitleHindi(location?.state?.data?.titleHindi);
//       setdescEnglish(location?.state?.data?.descEnglish);
//       setdescHindi(location?.state?.data?.descHindi);
//       seturl(location?.state?.data?.url);
//       setthumbnail(location?.state?.data?.thumbnail?.url);
//       const initialEditorState = RichTextEditor.createValueFromString(
//         location?.state?.data?.lyrics?.hindi,
//         "html"
//       );
//       const initialEditorState2 = RichTextEditor.createValueFromString(
//         location?.state?.data?.lyrics?.english,
//         "html"
//       );
//       setrte(initialEditorState);
//       setrte2(initialEditorState2);
//     }
//   }, [location]);

//   const onChange1 = (value) => {
//     setrte(value);
//     if (props.onChange) {
//       props.onChange(value.toString("html"));
//     }
//   };
//   const onChange2 = (value) => {
//     console.log(
//       value,
//       "value ==========================================================================================="
//     );
//     setrte2(value);
//     if (props.onChange) {
//       props.onChange(value.toString("html"));
//     }
//   };

//   const create_user = async () => {
//     if (pagetype == "Add") {
//       const fd = new FormData();
//       fd.append("titleEnglish", titleEnglish);
//       fd.append("titleHindi", titleHindi);
//       fd.append("descEnglish", descEnglish);
//       fd.append("descHindi", descHindi);
//       fd.append("url", url);
//       fd.append("mediaType", "audio");
//       fd.append(
//         "lyrics",
//         JSON.stringify({
//           hindi: rte.toString("html"),
//           english: rte2.toString("html"),
//         })
//       );
//       fd.append("tags", tags);
//       fd.append("thumbnail", thumbnail);

//       try {
//         let res = await addLanguage_api(fd);
//         if (res.data.status) {
//           navigate("/library-media");
//           notificationHandler({ type: "success", msg: res.data.message });
//         } else {
//           notificationHandler({ type: "success", msg: res.data.message });
//         }
//       } catch (error) {
//         notificationHandler({ type: "danger", msg: error.message });
//         console.log(error);
//       }
//     }
//     if (pagetype == "Edit") {
//       const fd = new FormData();
//       fd.append("titleEnglish", titleEnglish);
//       fd.append("titleHindi", titleHindi);
//       fd.append("descEnglish", descEnglish);
//       fd.append("descHindi", descHindi);
//       fd.append("url", url);
//       fd.append("mediaType", "audio");
//       fd.append(
//         "lyrics",
//         JSON.stringify({
//           hindi: rte.toString("html"),
//           english: rte2.toString("html"),
//         })
//       );
//       fd.append("tags", tags);
//       fd.append("thumbnail", thumbnail);
//       try {
//         let res = await updateLanguage_api(fd, location?.state?.data?._id);
//         if (res.data.status) {
//           navigate("/library-media");
//           notificationHandler({ type: "success", msg: res.data.message });
//         } else {
//           notificationHandler({ type: "success", msg: res.data.message });
//         }
//       } catch (error) {
//         notificationHandler({ type: "danger", msg: error.message });
//         console.log(error);
//       }
//     }
//   };

//   const fetchallTagFunc = async () => {
//     console.log("This is a testing");
//     // let temp = {
//     //   page: pageCount,
//     //   limit: 15,
//     //   search: search?.trim(),
//     // };
//     try {
//       let res = await get_all_tag_list_dropdown();
//       if (res.data.status) {
//         setallTag(res?.data?.data?.tags);
//       } else {
//         console.log("false Status!");
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   return (
//     <>
//       <div className="">
//         <Card className={s["admin_container"]}>
//           <div className={s["title"]} onClick={() => navigate(-1)}>
//             <BiArrowBack />
//             Back
//           </div>
//           <Grid
//             container
//             rowSpacing={1}
//             columnSpacing={{ xs: 1, sm: 2, md: 3 }}
//           >
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Title English</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="titleEnglish"
//                   value={titleEnglish}
//                   onChange={(e) => settitleEnglish(e.target.value)}
//                   placeholder="Title English"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Title Hindi</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="titleHindi"
//                   value={titleHindi}
//                   onChange={(e) => settitleHindi(e.target.value)}
//                   placeholder="Title Hindi"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Desc English</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="descEnglish"
//                   value={descEnglish}
//                   onChange={(e) => setdescEnglish(e.target.value)}
//                   placeholder="Desc English"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Desc Hindi</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="descHindi"
//                   value={descHindi}
//                   onChange={(e) => setdescHindi(e.target.value)}
//                   placeholder="Desc Hindi"
//                 />
//               </div>
//             </Grid>
//             {/* this is change into the mp4 file for the mobile app */}
//             {/* <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">URL</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="url"
//                   value={url}
//                   onChange={(e) => seturl(e.target.value)}
//                   placeholder="url"
//                 />
//               </div>
//             </Grid> */}
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label htmlFor="videoFile">Upload MP3/MP4 File</label>
//                 <input
//                   type="file"
//                   id="videoFile"
//                   className="form-control"
//                   accept="video/mp4,audio/mp4, audio/mpeg"
//                   onChange={(e) => seturl(e.target.files[0])}
//                 />
//               </div>
//             </Grid>
//             {/* <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Tags</label>
//                 <select
//                   className="form-control"
//                   value={tags.join(" ,")}
//                   onChange={(e) => settags([...tags, e.target.value])}
//                 >
//                   <option default>Select Tag</option>
//                   {allTag?.map((row, id) => (
//                     <option value={row?.id}>{row?.name}</option>
//                   ))}
//                 </select>
//               </div>
//             </Grid> */}
//             <Grid item xs={6}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Tags</label>
//                 <MultipleSelect settags={settags} />
//               </div>
//             </Grid>
//             <Grid item xs={12}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Thumbnail</label>
//                 <input
//                   type="file"
//                   className="form-control"
//                   name="thumbnail"
//                   // value={thumbnail}
//                   onChange={(e) => setthumbnail(e.target.files[0])}
//                   placeholder="Thumbnail"
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={12}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Lyrics (Hindi)</label>
//                 <RichTextEditor
//                   value={rte}
//                   className="employment_jobdescribee"
//                   onChange={onChange1}
//                 />
//               </div>
//             </Grid>
//             <Grid item xs={12}>
//               <div className="form-group">
//                 <label for="exampleInputEmail1">Lyrics (English)</label>
//                 <RichTextEditor
//                   value={rte2}
//                   className="employment_jobdescribee"
//                   onChange={onChange2}
//                 />
//               </div>
//             </Grid>
//           </Grid>
//           <div className={s["form-login-btn"]} onClick={() => create_user()}>
//             <Custombutton>Submit</Custombutton>
//           </div>
//         </Card>
//       </div>
//     </>
//   );
// };

// export default AddLibraryMedia;

import React, { useState, useEffect } from "react";
import s from "./language.module.css";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useLocation } from "react-router-dom";
import Custombutton from "../../Common/Custombutton";
import { notificationHandler } from "../../utils/Notification";
import { Card, Grid } from "@mui/material";
import RichTextEditor from "react-rte-17";
import { get_all_tag_list_dropdown } from "../api/tag";
import MultipleSelect from "./MultipleSelect";
import { addLanguage_api, updateLanguage_api } from "../api/librarymedia";

const AddLibraryMedia = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [titleEnglish, settitleEnglish] = useState("");
  const [titleHindi, settitleHindi] = useState("");
  const [descEnglish, setdescEnglish] = useState("");
  const [descHindi, setdescHindi] = useState("");
  const [thumbnail, setthumbnail] = useState("");

  const [rte, setrte] = useState(RichTextEditor.createEmptyValue());
  const [rte2, setrte2] = useState(RichTextEditor.createEmptyValue());

  const [tags, settags] = useState([]);
  const [allTag, setallTag] = useState([]);

  const pagetype = location.state?.pagetype;

  // 🔥 MULTIPLE AUDIO STATE
  const [audioList, setAudioList] = useState([
    { tempId: "new1", nameEnglish: "", nameHindi: "", file: null },
  ]);

  useEffect(() => {
    fetchallTagFunc();
  }, []);

  // ---------------- AUDIO HANDLERS ----------------

  const handleAudioChange = (index, field, value) => {
    const updated = [...audioList];
    updated[index][field] = value;
    setAudioList(updated);
  };

  const addMoreAudio = () => {
    setAudioList([
      ...audioList,
      {
        tempId: "new" + (audioList.length + 1),
        nameEnglish: "",
        nameHindi: "",
        file: null,
      },
    ]);
  };

  const removeAudio = (index) => {
    const updated = audioList.filter((_, i) => i !== index);
    setAudioList(updated);
  };

  // ---------------- RTE ----------------

  const onChange1 = (value) => {
    setrte(value);
  };

  const onChange2 = (value) => {
    setrte2(value);
  };

  // ---------------- API CALL ----------------

  const create_user = async () => {
    const fd = new FormData();

    fd.append("titleEnglish", titleEnglish);
    fd.append("titleHindi", titleHindi);
    fd.append("descEnglish", descEnglish);
    fd.append("descHindi", descHindi);
    fd.append("mediaType", "audio");

    fd.append(
      "lyrics",
      JSON.stringify({
        hindi: rte.toString("html"),
        english: rte2.toString("html"),
      })
    );

    fd.append("tags", tags);
    fd.append("thumbnail", thumbnail);

    // 🔥 AUDIO JSON
    const audioMeta = audioList.map((item) => ({
      tempId: item.tempId,
      nameEnglish: item.nameEnglish,
      nameHindi: item.nameHindi,
    }));

    fd.append("audioData", JSON.stringify(audioMeta));

    // 🔥 AUDIO FILES
    audioList.forEach((item) => {
      if (item.file) {
        fd.append(`file_${item.tempId}`, item.file);
      }
    });

    try {
      let res;
      if (pagetype === "Edit") {
        res = await updateLanguage_api(fd, location?.state?.data?._id);
      } else {
        res = await addLanguage_api(fd);
      }

      if (res.data.status) {
        navigate("/library-media");
        notificationHandler({ type: "success", msg: res.data.message });
      } else {
        notificationHandler({ type: "danger", msg: res.data.message });
      }
    } catch (error) {
      notificationHandler({ type: "danger", msg: error.message });
    }
  };

  // ---------------- TAG API ----------------

  const fetchallTagFunc = async () => {
    try {
      let res = await get_all_tag_list_dropdown();
      if (res.data.status) {
        setallTag(res?.data?.data?.tags);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // ---------------- UI ----------------

  return (
    <Card className={s["admin_container"]}>
      <div className={s["title"]} onClick={() => navigate(-1)}>
        <BiArrowBack /> Back
      </div>

      <Grid container spacing={2}>
        {/* TITLE */}
        <Grid item xs={6}>
          <input
            className="form-control"
            placeholder="Title English"
            value={titleEnglish}
            onChange={(e) => settitleEnglish(e.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <input
            className="form-control"
            placeholder="Title Hindi"
            value={titleHindi}
            onChange={(e) => settitleHindi(e.target.value)}
          />
        </Grid>

        {/* DESC */}
        <Grid item xs={6}>
          <input
            className="form-control"
            placeholder="Desc English"
            value={descEnglish}
            onChange={(e) => setdescEnglish(e.target.value)}
          />
        </Grid>

        <Grid item xs={6}>
          <input
            className="form-control"
            placeholder="Desc Hindi"
            value={descHindi}
            onChange={(e) => setdescHindi(e.target.value)}
          />
        </Grid>

        {/* TAGS */}
        <Grid item xs={6}>
          <MultipleSelect settags={settags} />
        </Grid>

        {/* THUMBNAIL */}
        <Grid item xs={6}>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setthumbnail(e.target.files[0])}
          />
        </Grid>

        {/* 🔥 MULTIPLE AUDIO */}
       <Grid item xs={12}>
  <div className="form-group">
    <label>Audio List</label>

    {audioList.map((audio, index) => (
      <Card
        key={audio.tempId}
        style={{
          padding: "15px",
          marginBottom: "15px",
          borderRadius: "10px",
        }}
      >
        <Grid container spacing={2}>
          {/* Name English */}
          <Grid item xs={4}>
            <div className="form-group">
              <label>Name English</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter English Name"
                value={audio.nameEnglish}
                onChange={(e) =>
                  handleAudioChange(index, "nameEnglish", e.target.value)
                }
              />
            </div>
          </Grid>

          {/* Name Hindi */}
          <Grid item xs={4}>
            <div className="form-group">
              <label>Name Hindi</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Hindi Name"
                value={audio.nameHindi}
                onChange={(e) =>
                  handleAudioChange(index, "nameHindi", e.target.value)
                }
              />
            </div>
          </Grid>

          {/* File Upload */}
          <Grid item xs={3}>
            <div className="form-group">
              <label>Upload Audio</label>
              <input
                type="file"
                className="form-control"
                accept="audio/mpeg"
                onChange={(e) =>
                  handleAudioChange(index, "file", e.target.files[0])
                }
              />
            </div>
          </Grid>

          {/* Remove Button */}
          <Grid item xs={1} style={{ display: "flex", alignItems: "end" }}>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeAudio(index)}
            >
              X
            </button>
          </Grid>
        </Grid>
      </Card>
    ))}

    {/* Add Button */}
    <button
      type="button"
      className="btn btn-primary"
      onClick={addMoreAudio}
    >
      + Add More Audio
    </button>
  </div>
</Grid>

        {/* RTE */}
        <Grid item xs={12}>
          <RichTextEditor value={rte} onChange={onChange1} />
        </Grid>
        <Grid item xs={12}>
          <RichTextEditor value={rte2} onChange={onChange2} />
        </Grid>
      </Grid>
      <div className={s["form-login-btn"]} onClick={create_user}>
        <Custombutton>Submit</Custombutton>
      </div>
    </Card>
  );
};
export default AddLibraryMedia; 